import { generateFingerPrinter, getPublicIP } from '@/utils/uuid';
export interface UserState {
    _id?: string;
    display_name?: string;
    op_active: boolean;
    userUUid: string;
    ip?: string;
    op_role?: string;
    platform?: string;
}
const userStore = defineStore({
    id: 'user',
    state: (): UserState => {
        return {
            _id: undefined,
            display_name: undefined,
            op_active: false,
            userUUid: '',
            ip: undefined,
            op_role: undefined,
            platform: undefined,
        };
    },
    getters: {
        getUserName: state => state.display_name,
        getUserUUid: state => state.userUUid,
        getUserId: state => state._id,
        getIp: state => state.ip,
        getOPActive: state => state.op_active,
        getRole: state => state.op_role,
        getPlatform: state => state.platform,
    },
    actions: {
        setUserInfo(userInfo: UserState) {
            if (!this.userUUid) {
                // this.userUUid = generateFingerPrinter();
            }
            console.log(userInfo, '--');
            this._id = userInfo._id;
            this.display_name = userInfo.display_name;
            this.op_active = userInfo.op_active;
            this.op_role = userInfo.op_role;
            this.platform = userInfo.platform;
        },
        clearUserInfo() {
            this._id = undefined;
            this.display_name = undefined;
            this.op_active = false;
        },
        async setIp() {
            if (!this.ip) {
                // this.ip = await getPublicIP();
            }
        },
    },
    persist: {
        storage: localStorage,
    },
});

export default userStore;
